import { Mail } from "lucide-react";
import { CONTACT } from "@/lib/content";
import { WhatsAppIcon, InstagramIcon } from "./Icons";
import { BookingForm } from "./BookingForm";

const Direct = ({ href, icon, label, testId, cls }) => (
  <a href={href} target="_blank" rel="noopener noreferrer" className={`inline-flex items-center gap-3 rounded-full px-5 py-3 text-sm transition-transform hover:-translate-y-0.5 ${cls}`} data-testid={testId}>
    {icon}{label}
  </a>
);

export const Booking = () => (
  <section id="cita" className="relative overflow-hidden hero-bg py-24 sm:py-32 scroll-mt-24" data-testid="booking-section">
    <img src="/brand/flowers-br.png" alt="" className="pointer-events-none absolute -bottom-24 -left-24 w-72 opacity-70 -scale-x-100" />
    <div className="relative max-w-[1440px] mx-auto px-5 sm:px-8 grid lg:grid-cols-2 gap-14 items-start">
      <div>
        <p className="eyebrow text-granate flex items-center gap-3"><span className="w-8 h-px bg-granate" />Agenda una cita</p>
        <h2 className="mt-6 font-display text-4xl sm:text-5xl lg:text-6xl leading-[1.05]" data-testid="booking-title">Las buenas fechas vuelan. Hablemos.</h2>
        <p className="mt-6 max-w-md text-ink/70 leading-relaxed">Cuéntanos qué celebras, cuándo y para cuántas personas. Te respondemos en un día laborable para concertar una cita, sin compromiso.</p>
        <p className="mt-12 eyebrow text-ink/60">¿Prefieres la vía rápida?</p>
        <p className="mt-3 text-ink/70">Escríbenos por WhatsApp o llámanos al <a href={`tel:${CONTACT.tel}`} className="text-granate font-medium hover:underline" data-testid="booking-phone-link">{CONTACT.phone}</a>.</p>
        <div className="mt-5 flex flex-col sm:flex-row sm:flex-wrap gap-3">
          <Direct href={CONTACT.waUrl} icon={<WhatsAppIcon className="w-5 h-5" />} label="WhatsApp" testId="booking-whatsapp-link" cls="bg-[#25D366] text-white" />
          <Direct href={`mailto:${CONTACT.email}`} icon={<Mail className="w-5 h-5" />} label={CONTACT.email} testId="booking-email-link" cls="bg-white border border-ink/10" />
          <Direct href={CONTACT.instagramUrl} icon={<InstagramIcon className="w-5 h-5" />} label={CONTACT.instagram} testId="booking-instagram-link" cls="bg-white border border-ink/10" />
        </div>
      </div>
      <BookingForm />
    </div>
  </section>
);
